<template>
  <div class="request_form">
    <form class="form-horizontal" @submit.prevent="submitForm">
      <fieldset>
        <legend>Artpack Request</legend>
        <div class="form-group">
          <label class="control-label col-sm-4">Department</label>
          <div class="col-sm-8">
            <select class="form-control" v-model="form.department">
              <option value="imperial">Golf</option>
              <option value="dl">DL</option>
              <option value="special_events">Special Events</option>
            </select>
          </div>
        </div>
        <div class="form-group">
          <label class="control-label col-sm-4">Artpack Type</label>
          <div class="col-sm-8">
            <select class="form-control" v-model="form.artpack_type">
              <option value="cap">Apparel / Cap</option>
              <option value="belt">Belt</option>
            </select>
          </div>
        </div>
        <div class="form-group">
          <label class="control-label col-sm-4">Account Name</label>
          <div class="col-sm-8">
            <input class="form-control" v-model="form.account_name" required>
          </div>
        </div>
        <div class="form-group">
          <label class="control-label col-sm-4">Account #</label>
          <div class="col-sm-8">
            <input class="form-control" v-model="form.account_number" required>
          </div>
        </div>
        <div class="form-group" v-if="form.artpack_type === 'belt'">
          <label class="control-label col-sm-4">Division</label>
          <div class="col-sm-8">
            <v-select v-model="form.division" :options="divisionOptions" />
          </div>
        </div>
        <div class="form-group">
          <label class="control-label col-sm-4">CSR</label>
          <div class="col-sm-8">
            <v-select v-if="csrOptions.length" v-model="form.csr_name" :options="csrOptions" />
          </div>
        </div>
        <div class="form-group">
          <label class="control-label col-sm-4">Customer Email For Proof</label>
          <div class="col-sm-8">
            <input class="form-control" v-model="form.customer_email_for_proofs">
          </div>
        </div>
      </fieldset>

      <fieldset>
        <legend>Details</legend>
        <div class="form-group">
          <label class="control-label col-sm-4">Artpack Name</label>
          <div class="col-sm-8">
            <input class="form-control" v-model="form.artpack_name" required>
          </div>
        </div>
        <div class="form-group">
          <label class="control-label col-sm-4">Reference Art</label>
          <div class="col-sm-8">
            <input class="form-control" v-model="form.reference_tapes">
          </div>
        </div>
        <div class="form-group" v-if="form.artpack_type === 'belt'">
          <label class="control-label col-sm-4">Type Of Belt</label>
          <div class="col-sm-8">
            <select class="form-control" v-model="form.type_of_belt">
              <option value="">Select Belt Type</option>
              <option value="Embroidered">Embroidered</option>
              <option value="Tournament - Cut To Size">Tournament - Cut To Size</option>
              <option value="Sublimated">Sublimated</option>
            </select>
          </div>
        </div>
        <div class="form-group" v-if="form.artpack_type === 'belt'">
          <label class="control-label col-sm-4">Color Options</label>
          <div class="col-sm-8">
            <select class="form-control" v-model="form.color_options">
              <option value="">Select Color Options</option>
              <option value="Club Colors">Club Colors</option>
              <option value="Color Coordinate-white">Color Coordinate-white</option>
              <option value="Color Coordinate-navy">Color Coordinate-navy</option>
              <option value="See Comments Below">See Comments Below</option>
            </select>
          </div>
        </div>
        <div class="form-group" v-if="form.artpack_type === 'belt'">
          <label class="control-label col-sm-4">Standard / Custom</label>
          <div class="col-sm-8">
            <select class="form-control" v-model="form.standard_custom">
              <option value="">Select Standard / Custom</option>
              <option value="Standard">Standard</option>
              <option value="Custom">Custom</option>
            </select>
          </div>
        </div>
        <div class="form-group" v-if="form.artpack_type === 'belt'">
          <label class="control-label col-sm-4">Location</label>
          <div class="col-sm-8">
            <input class="form-control" v-model="form.location">
          </div>
        </div>
        <div class="form-group">
          <label class="control-label col-sm-4">Event</label>
          <div class="col-sm-8">
            <select class="form-control" v-model="form.event">
              <option :value="0">No</option>
              <option :value="1">Yes</option>
            </select>
          </div>
        </div>
        <div class="form-group" v-if="form.event">
          <label class="control-label col-sm-4">Event Due Date</label>
          <div class="col-sm-8">
            <input class="form-control" v-model="form.event_due_date" placeholder="MM/DD/YYYY">
          </div>
        </div>
        <div class="form-group" v-if="form.artpack_type !== 'belt'">
          <label class="control-label col-sm-4">Prebook</label>
          <div class="col-sm-8">
            <select class="form-control" v-model="form.pre_book">
              <option :value="0">No</option>
              <option :value="1">Yes</option>
            </select>
          </div>
        </div>
        <div class="form-group" v-if="form.pre_book">
          <label class="control-label col-sm-4">Prebook Date</label>
          <div class="col-sm-8">
            <input class="form-control" v-model="form.prebook_date" placeholder="MM/DD/YYYY">
          </div>
        </div>
      </fieldset>

      <fieldset>
        <legend>Comments</legend>
        <div class="form-group">
          <label class="control-label col-sm-12" style="text-align:left;">Request Comments</label>
          <div class="col-sm-12">
            <textarea class="form-control" rows="6" v-model="form.comments" required></textarea>
          </div>
        </div>
      </fieldset>

      <div class="form-actions">
        <button type="submit" class="btn btn-primary">Submit Request</button>
      </div>
    </form>
  </div>
</template>

<script>
import axios from 'axios'
import { buildRequestPrefill } from './request_prefill'

export default {
  name: 'ArtpackRequest',
  props: ['newData', 'group'],
  data () {
    return {
      csrOptions: [],
      divisionOptions: ['ADG', 'Amusement', 'ASI', 'Branded Apparel', 'Fashion Brands', 'Imperial', 'Retail', 'Team Dealer'],
      form: {
        department: 'imperial',
        artpack_type: 'cap',
        account_name: '',
        account_number: '',
        division: 'Imperial',
        csr_name: '',
        customer_email_for_proofs: '',
        artpack_name: '',
        reference_tapes: '',
        type_of_belt: '',
        color_options: '',
        standard_custom: '',
        location: '',
        event: 0,
        event_due_date: '',
        pre_book: 0,
        prebook_date: '',
        comments: '',
        package_domestic: 1,
        package_total: 1
      }
    }
  },
  mounted () {
    this.getCsrs()
    this.applyPrefill()
  },
  methods: {
    getCsrs () {
      axios.post(this.$apiAdress + '/api/flow/getCsrs?token=' + localStorage.getItem('api_token')).then(response => {
        this.csrOptions = (response.data || []).map(user => ({
          value: user.id,
          label: user.name
        }))
      })
    },
    applyPrefill () {
      if (!this.newData) return
      const prefill = buildRequestPrefill(this.newData, this.group || {})
      this.form.account_name = prefill.accountName
      this.form.account_number = prefill.accountNumber
      this.form.division = prefill.programName || 'Imperial'
      this.form.artpack_name = prefill.title
      this.form.reference_tapes = prefill.reference
      this.form.location = [prefill.locationCode, prefill.locationName].filter(Boolean).join(' - ')
      this.form.comments = prefill.comments
      this.form.package_total = prefill.styles.length || 1
      if (prefill.techniqueName && prefill.techniqueName.toLowerCase().indexOf('belt') > -1) {
        this.form.artpack_type = 'belt'
      }
    },
    submitForm () {
      const postData = {
        form: this.form
      }
      axios.post(this.$apiAdress + '/api/flow/submitArtpack?token=' + localStorage.getItem('api_token'), postData).then(() => {
        this.$emit('submitted')
      })
    }
  }
}
</script>
